import * as z from "zod";
import { returnsAnalyticsDataQualitySchema } from "./returns-analytics-shared";

export const getReturnsStuckOnboardingsInputSchema = z.object({
  /** Rows untouched for at least this many days. Default 7. */
  stuckDaysThreshold: z.number().int().min(1).max(365).default(7),
  /** Max rows to return. Default 100. */
  limit: z.number().int().min(1).max(500).default(100),
});
export type GetReturnsStuckOnboardingsInput = z.infer<
  typeof getReturnsStuckOnboardingsInputSchema
>;

const stuckOnboardingSchema = z.object({
  teamId: z.string(),
  currentStepId: z.string(),
  status: z.enum(["partial-completion", "help-requested"]),
  dealSizeBucket: z.string(),
  hubspotDealId: z.string().nullable(),
  hubspotDealName: z.string().nullable(),
  daysSinceUpdate: z.number().int().min(0),
  daysSinceStart: z.number().int().min(0),
  startedAt: z.date(),
  updatedAt: z.date(),
});
export type ReturnsStuckOnboardingRow = z.infer<typeof stuckOnboardingSchema>;

export const getReturnsStuckOnboardingsOutputSchema = z.object({
  onboardings: z.array(stuckOnboardingSchema),
  totalStuck: z.number().int().min(0),
  dataQuality: returnsAnalyticsDataQualitySchema,
});
export type GetReturnsStuckOnboardingsOutput = z.infer<
  typeof getReturnsStuckOnboardingsOutputSchema
>;

export const getReturnsStuckOnboardings = {
  name: "getReturnsStuckOnboardings" as const,
  input: getReturnsStuckOnboardingsInputSchema,
  output: getReturnsStuckOnboardingsOutputSchema,
};
